export enum PpwrDocumentType {
  DoC = 0,
  TD = 1,
}

export enum PpwrDocumentSource {
  UserUploaded = 0,
  PacoGenerated = 1,
}

export interface PpwrDocumentDto {
  index: number;
  name: string;
  source: PpwrDocumentSource;
  documentType: PpwrDocumentType;
  description?: string;
  documentId: number;
}
